import React, { useEffect } from "react";
import { defaultURL, panduanKonsumenMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import { panduanKonsumenBreadcrumb } from "../../data/DataBreadcrumb";
import PanduanKonsumenBlocks from "../../components/PanduanKonsumen/PanduanKonsumenBlocks";
import { DownloadLink } from "../../components/UserInterface/DownloadLink";
import downloadIcon from "../../../public/static/images/svg/download-icon.svg";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import { GACustomEvent } from "src/utils/analytics";

const PanduanKonsumen = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];
  useEffect(() => {
    GACustomEvent("customer_guide_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={panduanKonsumenBreadcrumb} />
      <HeadingComponent headingText="Panduan Konsumen" />
      <PanduanKonsumenBlocks />
      <LayoutCenter column>
        <HeadingComponent headingText="Syarat & Ketentuan Umum" />
        <DownloadLink
          url="/static/pdf/Perjanjian-Pembiayaan-Multiguna.pdf"
          img={downloadIcon}
          linkName="Klik di sini untuk melihat syarat dan ketentuan umum mengenai pembiayaan multiguna"
        />
        <DownloadLink
          url="/static/pdf/Informasi-Umum-untuk-Pelanggan-Home-Credit.pdf"
          img={downloadIcon}
          linkName="Klik di sini untuk melihat Informasi Umum untuk Pelanggan Home Credit"
        />
      </LayoutCenter>
    </Layout>
  );
};

PanduanKonsumen.getInitialProps = ({ asPath }) => {
  const pageTitle = panduanKonsumenMeta.title;
  const descriptionSEO = panduanKonsumenMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default PanduanKonsumen;
